(function () {
    'use strict';

    angular
        .module('committeeEditModule', [
            'services.authenticatedUser',
            'aricModule',
            'governanceProcessModule',
            'services.attachments',
            'services.historyCtxt',
            'committeeModule'
        ]);
})();
